export default __webpack_public_path__ + "static/media/Pistol_8.9f48b00c.png";